import { useState, useCallback, useEffect } from 'react';

interface UseChallengeExpansionReturn {
  isExpanded: boolean;
  showAllMatches: boolean;
  toggleExpand: () => void;
  handleShowAllMatches: () => void;
}

export const useChallengeExpansion = (initialExpanded = false): UseChallengeExpansionReturn => {
  const [isExpanded, setIsExpanded] = useState(initialExpanded);
  const [showAllMatches, setShowAllMatches] = useState(false);

  // Sync expand when opening from deep link (card may mount after scroll, or re-render with param set)
  useEffect(() => {
    if (initialExpanded) setIsExpanded(true);
  }, [initialExpanded]);

  const toggleExpand = useCallback(() => {
    setIsExpanded((prev) => {
      const next = !prev;
      if (!next) {
        setShowAllMatches(false);
      }
      return next;
    });
  }, []);

  const handleShowAllMatches = useCallback(() => {
    setShowAllMatches(true);
  }, []);

  return {
    isExpanded,
    showAllMatches,
    toggleExpand,
    handleShowAllMatches,
  };
};

